var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 .67a.67.67 0 0 0-.214-.483C11.652.08 11.49 0 11.33 0H.67a.67.67 0 0 0-.483.188A.65.65 0 0 0 0 .67v10.66c0 .188.054.349.188.482.107.134.267.188.482.188h5.732V7.34H4.848V5.544h1.554v-1.34q0-1.125.643-1.767c.428-.402.99-.617 1.687-.617.536 0 1.018.027 1.393.054v1.634h-.964q-.523 0-.723.241-.162.2-.161.643v1.152h1.794l-.24 1.794H8.276V12h3.053a.65.65 0 0 0 .482-.187.77.77 0 0 0 .188-.483z"
  })));
};
export default SvgFacebook;